var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 =
    _vm.itemData.style.display == "list"
      ? _vm.__map(_vm.itemData.data, function (product, index) {
          var $orig = _vm.__get_orig(product)
          var m0 = _vm.isInArray2(
            _vm.city_supplier_ids,
            product.shop_supplier_id
          )
          return {
            $orig: $orig,
            m0: m0,
          }
        })
      : null
  var l1 = !(_vm.itemData.style.display == "list")
    ? _vm.__map(_vm.itemData.data, function (product, index) {
        var $orig = _vm.__get_orig(product)
        var m1 = _vm.isInArray2(_vm.city_supplier_ids, product.shop_supplier_id)
        return {
          $orig: $orig,
          m1: m1,
        }
      })
    : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
        l1: l1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }